import React, { useEffect, useState, FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

//Services
import { getCycles, updateCycle } from '../../services/CycleService';
// import { updateGroupsCycle } from '../../services/GroupService';

//Components
import ActivityModal from '../common/ActivityModal';
import ActivityTable from '../common/ActivityTable';
import ActivityLoading from '../common/ActivityLoading';

//Types
import { CycleInterface, ModalOptionsInterface, TableColumnInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

//Icons
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

const CycleList: FC = (props) => {
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: "", buttons: [] });
    const [cycles, setCycles] = useState<Array<CycleInterface>>([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        fetchCycles();
    }, [])

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Nombre", value: "name" },
        {
            title: "Fecha de inicio",
            value: "start_date",
            render: (data: CycleInterface) => data.start_date ?
                <div className="container-center">{moment(data.start_date.toDate()).format("DD-MM-YYYY")}</div> : ""
        },
        {
            title: "Fecha de fin",
            value: "end_date",
            render: (data: CycleInterface) => data.end_date ?
                <div className="container-center">{moment(data.end_date.toDate()).format("DD-MM-YYYY")}</div> : ""
        },
        {
            value: "buttons",
            render: (data: CycleInterface) =>
                <div className="buttons-container-center">
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => goToUpdateCycle(data)}>
                        <FaPencilAlt />
                    </Button>
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => handleDisableCycle(data)}>
                        <FaTrash />
                    </Button>
                </div>
        }
    ]

    const fetchCycles = () => {
        getCycles().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
            setCycles(response as Array<CycleInterface>)
            setLoading(false);
        })
    }

    const goToUpdateCycle = (cycle: CycleInterface) => {
        history.push({ pathname: `/cycle/edit/${cycle.id}` });
    }

    const handleDisableCycle = (cycle: CycleInterface) => {
        setModal({
            open: true,
            header: "Borrar",
            body: "Estas seguro de que quieres borrar este ciclo?",
            buttons: [
                { text: "Borrar", func: () => disableCycle(cycle) },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const disableCycle = (cycle: CycleInterface) => {
        setLoading(true);
        updateCycle(cycle.id, { deleted: true, groups: [] })
            .then((response: string) => {
                handleModalClose();
                if (response !== "error") {
                    fetchCycles();
                    // updateGroupsCycle("", "", cycle.groups, [])
                    //     .then((response: any) => {
                    //         if (response !== "error")
                    //             fetchCycles()
                    //     });
                }
            });
    }

    // const tableOptions: TableOptionsInterface = {
    //     search: (data: any) => console.log("All by myself", data),
    //     bottomPaginator: (data: any) => console.log(data),
    //     topPaginator: (data: any) => console.log(data)
    // }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <div style={{ marginBottom: '10px' }}>
                <h1>Ciclo escolar</h1>
            </div>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.push('/cycle/new')} >Agregar ciclo escolar</Button>
            </div>
            <ActivityTable data={cycles ? cycles : []} columns={tableColumns} /* options={tableOptions} */ />
        </Container>
    )
}

export default CycleList;
